module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-01.67710c1d.jpeg";